module.exports = __webpack_public_path__ + "img/category.e2494364.svg";